import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  yearlyReport: {
    id: 'views.ReportsView.YearlyReport.yearlyReport',
    defaultMessage: 'Raport roczny za {year} rok'
  },
  quarterlyReport: {
    id: 'views.ReportsView.QuarterlyReport.quarterlyReport',
    defaultMessage: 'Raport za {quarter} kwartał {year}r.'
  },
  watchReport: {
    id: 'views.ReportsView.YearlyReport.watchReport',
    defaultMessage: 'OBEJRZYJ MULTIMEDIALNY RAPORT'
  },
  downloadPDF: {
    id: 'views.ReportsView.YearlyReport.downloadPDF',
    defaultMessage: 'POBIERZ PLIK PDF'
  },
  downloadAttachment: {
    id: 'views.ReportsView.YearlyReport.downloadAttachment',
    defaultMessage: 'POBIERZ: '
  }
});



// WEBPACK FOOTER //
// ./src/views/Reports/components/Report/Report.intl.js